// Internal store state
let store = {
  runStatus: [],
  lockedOrders: [],
  lockedSchedules: [],
  forecastOverrideStatus: undefined,
}

// Listeners for subscriptions
const listeners = new Set<() => void>()

function emitChange() {
  for (const listener of listeners) listener()
}

// Public setter methods
export const websocketStore = {
  getSnapshot: () => store,

  subscribe(callback: () => void) {
    listeners.add(callback)
    return () => listeners.delete(callback)
  },

  update(updates: Partial<typeof store>) {
    store = { ...store, ...updates }
    emitChange()
  },
}
